import { Phone, MessageSquare } from "lucide-react";
import { useLang } from "@/LanguageContext";
import { PHONE_TEL } from "@/data/site";

export const StickyBar = () => {
  const { t } = useLang();
  return (
  <div
    data-testid="sticky-mobile-bar"
    className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t border-steel-700 md:hidden"
  >
    <a
      href={`tel:${PHONE_TEL}`}
      data-testid="sticky-call-btn"
      className="flex items-center justify-center gap-2 bg-forge py-4 font-head text-lg font-bold uppercase tracking-wide text-white"
    >
      <Phone size={19} strokeWidth={2.5} /> {t.hero.call}
    </a>
    <a
      href={`sms:${PHONE_TEL}`}
      data-testid="sticky-text-btn"
      className="flex items-center justify-center gap-2 bg-steel-800 py-4 font-head text-lg font-bold uppercase tracking-wide text-steel-50"
    >
      <MessageSquare size={19} strokeWidth={2.5} /> {t.hero.text}
    </a>
  </div>
  );
};
